document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.joe-text-contrast_wrapper');

  
  // 创建视口观察器
  const carouselObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 当轮播图进入视口时，初始化该轮播图
        initCarousel(entry.target);
        // 初始化后取消观察此轮播图
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '200px', // 提前200px开始加载
    threshold: 0.1      // 当10%的元素可见时触发
  });
  
  // 开始观察所有轮播图
  carousels.forEach(carousel => {
    carouselObserver.observe(carousel);
  });
  
  function initCarousel(carousel){
       const sectionId = carousel.getAttribute('data-section-id');
      const itemsContainer = carousel.querySelector(`.joe-text-contrast_items `); 

      /*nav*/
    const tabs = carousel.querySelectorAll(".text-contrast_header-nav_item");
    const indicator = carousel.querySelector(".text-contrast_header-nav_position");
    const imgs = itemsContainer.querySelectorAll(
      ".joe-text-contrast_img"
    );
    const contents = itemsContainer.querySelectorAll(
      ".joe-text-contrast_content"
    );
    
    let currentIndex = 0 ;
    let lastIndex = 0 ;

     // 初始化指示器位置
    const activeTab = carousel.querySelector(
      '.text-contrast_header-nav_item[aria-expanded="true"]'
    );
    if (activeTab) {
      updateIndicator(activeTab);
    }
    
     tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        tabs.forEach((t) => t.setAttribute("aria-expanded", "false"));
        this.setAttribute("aria-expanded", "true");
        updateIndicator(this);
        lastIndex = currentIndex ;
        currentIndex = parseInt(this.getAttribute("data-index"));
        updateItem(lastIndex,currentIndex);
      });
    });
    
    /*函数块*/
    function updateIndicator(tab) {
      indicator.style.width = `${tab.offsetWidth}px`;
      indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
    }

    function updateItem(lastIndex,currentIndex){
      imgs[lastIndex].style.opacity = "0";
      contents[lastIndex].style.opacity = "0";
      imgs[currentIndex].style.opacity = "1";
      contents[currentIndex].style.opacity = "1";
    }
    
  }           
}
)